module.exports = __webpack_public_path__ + "media/images/cake-2a65e06d.png";